export enum MeterIdentificationWorkflow {
  SensorInstallation = 'sensor-installation',
  SensorReplacement = 'sensor-replacement',
  MeterReplacement = 'meter-replacement',
  ServiceInspection = 'service-inspection',
}
